<template>
    <div class="modal fade bonus-point-modal balance-low" id="approvalBeforeRemoving" aria-modal="true" role="dialog">
         <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content">
               <div class="modal-header">
                <p class="check-blow-item">Transaction Password</p>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetField"></button>
               </div>
               <div class="modal-body p-body">
                  <div class="flex-box-item">
                    
                    <div class="input-relative">
                        <img src="@/assets/images/input-password.svg" alt="input-password" class="input-icn-img">
                        <input :type="transaction_passwordFieldType" :placeholder="$t('enter-transaction-password', 'Enter Transaction Password')+'*'" class="form-control profit-input"
                        @input="transaction_password = $helper.sanitizeDetails('oldLoginPassword', transaction_password)" v-model="transaction_password">
                        <i @click="togglePasswordVisibility('transaction_passwordFieldType')"  
                            :class="['fas', 'togglePassword', transaction_passwordFieldType === 'text' ? 'fa-eye' : 'fa-eye-slash']">
                        </i>
                    </div>
                  </div>
                  
               </div>
               <div class="modal-footer border-0">
                  <button type="button" class="btn btn-gradient" @click="removeAccount()">Remove</button>
               </div>
            </div>
        </div>
    </div>
</template>
<script>
import { removeAccount } from '@template/utils'
export default {
    name: 'ApprovalBeforeRemoving',
    props:{ 
        getUserAccounts: Function,
        selectedAccount: Object
    },
    data(){
        return{
            transaction_password: '',
            transaction_passwordFieldType : 'password',
        }
    },
    methods:{
        resetField(){
            this.transaction_password= '';
            this.transaction_passwordFieldType = 'password'
        },
        togglePasswordVisibility(fieldName) {
            this[fieldName] = this[fieldName] === 'password' ? 'text' : 'password';            
        },
        async removeAccount(){
            let response = await removeAccount(this.transaction_password,this.selectedAccount.client_account_id)
            if(response) {
                this.resetField()
                this.$helper.closeModal('approvalBeforeRemoving')
                this.getUserAccounts();
            }
        },
    }
}
</script>